// 사용자 정보 저장
import { defineStore } from "pinia";
import * as cmUtil from "@/utils/cmUtil";
import * as cmApi from "@/api/cmApi";
import { api } from "../plugins/api";
import router from "../router";
import { useOrderListStore } from "./useEventBusStore";

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    user: null,
    returnUrl: null, // 사용안함
  }),
  actions: {
    async login(param) {
      cmUtil.resetStore();
      const res = await api.post("/api/v1" + "/login/confirm", param);
      return res;
    },
    async loginInfo(res) {
      const userObj = { ...res.data };
      this.user = userObj;
      cmUtil.setUserPersonInfo();
      cmUtil.setLocalStorage("token", res.data.token);
      if (res.data.refreshTokenYn === "Y" && res.data.refreshToken) {
        cmUtil.setLocalStorage("token_refreshToken", res.data.refreshToken);
        cmUtil.setLocalStorage("token_refreshYn", res.data.refreshTokenYn);
      }
      //cmUtil.setLocalStorage("_token_time", res.data.tokenTime);
      //cmUtil.setLocalStorage("_token_refreshTime", res.data.refreshTokenTime);
      //cmUtil.setLocalStorage("_token_createDate", res.data.tokenCreateDate);
      //cmUtil.setLocalStorage("_token_newTokenTime", "");
      //cmUtil.setLocalStorage("_token_refreshCount", 0);
      useOrderListStore().resetItemList(); // 로그인시 제품주문 주문서영역 초기화
      await cmApi.setLoginInitData();
      let goBaseUrl = "/paintpro/main";
      //const _returnUrl = cmUtil.getLocalStorage("gv.returnUrl");
      //if (_returnUrl != null && _returnUrl.length > 3) {
      //  goBaseUrl = _returnUrl;
      //}
      cmUtil.removeLocalStorage("gv.returnUrl");
      //window.history.forward(0);
      router.replace({
        path: goBaseUrl,
      });
      //location.href = goBaseUrl;
    },
    setLoginUser(loginUser) {
      this.user = loginUser;
    },
    logout() {
      this.user = null;
      cmUtil.resetStore();
      //router.push({ name: "/paintpro/login" });
    },
    setReturnUrl(url) {
      this.returnUrl = url;
    },
  },
});
